import { Component } from '@angular/core';
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { ACNPipe } from "@shared/pipes/acnPipe";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import {
  SecurityholderName,
  SecurityholderViewModel
} from "@shared/components/entity-profiles/entity-securityholders-view/securityholder-view-model";

type CellRendererParams = ICellRendererParams<SecurityholderViewModel> & { pendingButtonState: boolean }

interface IEntitySecurityHolderLine extends SecurityholderName {
  areNamesDifferent: boolean;
  isNewName: boolean;
  isLineThrough: boolean;
  isNameRed: boolean;
}

@Component({
  selector: 'app-ag-entity-securityholder',
  standalone: true,
  imports: [
    ACNPipe,
    NgbTooltip,
  ],
  templateUrl: 'ag-entity-securityholder.component.html',
  styleUrl: 'ag-entity-securityholder.component.scss'
})
export class AgEntitySecurityholderComponent implements ICellRendererAngularComp {
  model: SecurityholderViewModel | null = null;
  holdersLines: IEntitySecurityHolderLine[] = [];
  pendingButtonState = false;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.pendingButtonState = params.pendingButtonState ?? this.pendingButtonState;
    this.model = params.data!;

    this.holdersLines = this.model.holdersNames.map((holderLine) => {
      const areNamesDifferent = Boolean(holderLine.name && holderLine.name != holderLine.previousName);
      const nameLineThroughClass = areNamesDifferent && this.model?.number ? 'line-through' : '';

      return {
        ...holderLine,
        areNamesDifferent,
        isNewName: Boolean(areNamesDifferent && this.model?.record.holdings.length),
        isLineThrough: Boolean(areNamesDifferent && this.model?.number),
        isNameRed: Boolean(!!nameLineThroughClass
          || this.model?.number == 0
          || !this.model?.holding)
      };
    });

    return true;
  }
}
